import api from './api';

/**
 * Service for ghat-related API calls
 */

/**
 * Fetch all ghats
 * @returns {Promise<Array>} Array of ghat data
 */
export const fetchAllGhats = async () => {
  try {
    const response = await api.get('/ghats');
    return response.data;
  } catch (error) {
    console.error('Error fetching ghats:', error);
    throw error;
  }
};

/**
 * Fetch a single ghat by ID
 * @param {string} ghatId - The ID of the ghat to fetch
 * @returns {Promise<Object>} Ghat data
 */
export const fetchGhatById = async (ghatId) => {
  try {
    const response = await api.get(`/ghats/${ghatId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ghat ${ghatId}:`, error);
    throw error;
  }
};

/**
 * Fetch featured ghats
 * @param {number} limit - Maximum number of ghats to fetch
 * @returns {Promise<Array>} Array of featured ghat data
 */
export const fetchFeaturedGhats = async (limit = 6) => {
  try {
    const response = await api.get('/ghats/featured', { params: { limit } });
    return response.data;
  } catch (error) {
    console.error('Error fetching featured ghats:', error);
    throw error;
  }
};
